import { render } from "./StartGame.vue?vue&type=template&id=a5fc4dc6&scoped=true"
import script from "./StartGame.vue?vue&type=script&lang=js"
export * from "./StartGame.vue?vue&type=script&lang=js"

import "./StartGame.vue?vue&type=style&index=0&id=a5fc4dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5fc4dc6"]])

export default __exports__